export default __webpack_public_path__ + "static/media/ic_menu_dots.87c2cfaa.svg";